import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { CandidateFileUploadComponent } from './candidate-file-upload.component';
import { UploadFilesModule } from 'src/app/shared/upload-files/upload-files.module';
import { SendCandidateOutreachEmailModule } from 'src/app/shared/send-candidate-outreach-email/send-candidate-outreach-email.module';

@NgModule({
  declarations: [CandidateFileUploadComponent],
  imports: [
    CommonModule,
    DropzoneModule,
    UploadFilesModule,
    SendCandidateOutreachEmailModule
  ],
  entryComponents: [CandidateFileUploadComponent],
  exports: [CandidateFileUploadComponent]
})
export class CandidateFileUploadModule { }
